export default "__VITE_ASSET__BLqpNT8p__"